import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Video_gallery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Video Gallery
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>News & PR</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Video Gallery</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section>
                    <div className="container">
                        <div
                            className="row mt_40 aos-init aos-animate"
                            data-aos="fade-up"
                            data-aos-delay={700}
                        >
                            <div className="col-md-12">
                                <div className="Gallery_section">
                                    <div
                                        className="row gutter-24 project-active-two"
                                        style={{ position: "relative", height: 225 }}
                                    >
                                        <div
                                            className="col-lg-3 col-md-6 grid-item grid-sizer"
                                            style={{ position: "absolute", left: "0%", top: 0 }}
                                        >
                                            <div className="galllary_img_div">
                                                <div className="project__item-two video_gallary">
                                                    <div className="project__thumb-two">
                                                        {/* <img src="assets/img/Gallary/video_1.jpg" alt="img" /> */}
                                                        <img src="assets/img/Gallary/itme-logo.png" alt="img" />
                                                        <p>ITMES Trade Services</p>
                                                    </div>
                                                </div>
                                                <a
                                                    href="https://youtu.be/ag47pOihPx4"
                                                    data-gallery="portfolioGallery"
                                                    className="portfolio-lightbox"
                                                    target="_blank"
                                                >
                                                    <i className="fa fa-video" />
                                                </a>
                                            </div>
                                        </div>
                                        {/* <div
                                            className="col-lg-3 col-md-6 grid-item grid-sizer"
                                            style={{ position: "absolute", left: "25%", top: 0 }}
                                        >
                                            <div className="galllary_img_div">
                                                <div className="project__item-two video_gallary">
                                                    <div className="project__thumb-two">
                                                        <img src="assets/img/Gallary/video_2.jpg" alt="img" />
                                                        <p>GTTES</p>
                                                    </div>
                                                </div>
                                                <a
                                                    href="https://www.youtube.com/embed/OYyZECjrz7w"
                                                    data-gallery="portfolioGallery"
                                                    className="portfolio-lightbox"
                                                    target="_blank"
                                                >
                                                    <i className="fa fa-video" />
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            className="col-lg-3 col-md-6 grid-item grid-sizer"
                                            style={{ position: "absolute", left: "50%", top: 0 }}
                                        >
                                            <div className="galllary_img_div">
                                                <div className="project__item-two video_gallary">
                                                    <div className="project__thumb-two">
                                                        <img src="assets/img/Gallary/video_3.jpg" alt="img" />
                                                        <p>India ITME Society</p>
                                                    </div>
                                                </div>
                                                <a
                                                    href="https://www.youtube.com/embed/h3vbPxz6Wzc"
                                                    data-gallery="portfolioGallery"
                                                    className="portfolio-lightbox"
                                                    target="_blank"
                                                >
                                                    <i className="fa fa-video" />
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            className="col-lg-3 col-md-6 grid-item grid-sizer"
                                            style={{ position: "absolute", left: "75%", top: 0 }}
                                        >
                                            <div className="galllary_img_div">
                                                <div className="project__item-two video_gallary">
                                                    <div className="project__thumb-two">
                                                        <img src="assets/img/Gallary/video_4.jpg" alt="img" />
                                                        <p>ITME Africa</p>
                                                    </div>
                                                </div>
                                                <a
                                                    href="https://www.youtube.com/embed/fib47zeouf8"
                                                    data-gallery="portfolioGallery"
                                                    className="portfolio-lightbox"
                                                    target="_blank"
                                                >
                                                    <i className="fa fa-video" />
                                                </a>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="product_launch" ></section> */}

                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Video_gallery));